module.exports = __webpack_public_path__ + "img/italiano.e5cec0c0.svg";